import Header from "../components/Header";
import Footer from "../components/Footer";
import Contact from "../components/contact";
import { Helmet } from "react-helmet";
import Banner from "../components/layout/Banner";

const ContactUs = () => {

  // 🎨 Luxury Theme
  const colors = {
    sectionBg: "#fcfaf8",
    accent: "#b76e79",
    dark: "#1a1a1a",
    text: "#5a5a5a",
    border: "#d6bfae",
  };

  return (
    <>
      <Helmet>
        <title>Contact Us - Dr Vibha Clinic | IVF & Fertility Center</title>
        <meta
          name="description"
          content="Contact Dr Vibha Clinic for expert IVF and fertility treatments. Book your appointment, visit our clinic, or speak with our specialists."
        />
      </Helmet>

      <Header />
        <Banner
        title="Contact Us"
        subtitle="Dedicated to Safe Motherhood & Women's Wellness"
        image="https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/A_patient_exam_room_at_an_urgent_care_clinic_and_doctor%E2%80%99s_office_in_North_Carolina%2C_United_States_06.jpg/1280px-A_patient_exam_room_at_an_urgent_care_clinic_and_doctor%E2%80%99s_office_in_North_Carolina%2C_United_States_06.jpg"
      />

      {/* ===== Page Hero Section ===== */}
      <section
        className="py-24 px-6 text-center"
        style={{ backgroundColor: colors.sectionBg }}
      >
        <div className="max-w-4xl mx-auto">

          <span
            className="uppercase tracking-[0.3em] text-xs font-semibold"
            style={{ color: colors.accent }}
          >
            Get In Touch
          </span>

          <h1
            className="text-4xl md:text-5xl font-light mt-6"
            style={{ color: colors.dark }}
          >
            We’re Here To{" "}
            <span style={{ color: colors.accent, fontWeight: 600 }}>
              Support You
            </span>
          </h1>

          <p
            className="mt-6 text-lg leading-relaxed"
            style={{ color: colors.text }}
          >
            Whether you have questions about fertility treatments, pregnancy care,
            or wish to book a consultation, our team is ready to guide you with
            compassion and expertise.
          </p>

          <div
            className="w-20 h-[2px] mx-auto mt-8"
            style={{ backgroundColor: colors.border }}
          />
        </div>
      </section>

      {/* ===== Contact Component Section ===== */}
      <section style={{ backgroundColor: "#ffffff" }}>
        <Contact />
      </section>

      <Footer />
    </>
  );
};

export default ContactUs;